<template>
	<div>
		<policy-submenu />

		<!-- MOCK: for aeg_uat, aeg we are mocking CMS for transaction -->
		<template
			v-if="
				$store.state.tenantId === 'aeg_uat' || $store.state.tenantId === 'aeg'
			"
		>
			<aeg-policy-transactions-list />
		</template>

		<!-- MOCK for demo_uat -->
		<template
			v-else-if="
				$store.state.tenantId === 'demo_uat' || $store.state.tenantId === 'demo'
			"
		>
			<demo-policy-transactions-list />
		</template>

		<!-- MOCK for demo2_uat -->
		<template v-else-if="$store.state.tenantId === 'demo2_uat'">
			<demo2-policy-transactions-list />
		</template>

		<!-- MOCK: all other tenants have default -->
		<template v-else>
			<default-policy-transactions-list />
		</template>
	</div>
</template>

<script>
import PolicySubmenu from "../components/PolicySubmenu"

// mocked cms components
import DefaultPolicyTransactionsList from "../components/mockedCms/DefaultPolicyTransactionsList.vue"
import AegPolicyTransactionsList from "../components/mockedCms/AegPolicyTransactionsList.vue"
import DemoPolicyTransactionsList from "../components/mockedDemo/DemoPolicyTransactionsList"
import Demo2PolicyTransactionsList from "../components/mockedDemo2/Demo2PolicyTransactionsList"

export default {
	components: {
		PolicySubmenu,
		DefaultPolicyTransactionsList,
		AegPolicyTransactionsList,
		DemoPolicyTransactionsList,
		Demo2PolicyTransactionsList
	},

	props: {
		// From router
		id: String
	}
}
</script>
